// src/sagas/index.js
import { all } from "redux-saga/effects";
import gallerySaga from "./gallerySaga";
import artistSaga from "./artistSaga";
import libraryCardSaga from "./libraryCardSaga";
import blogSaga from "./blogSaga";
import storeSaga from "./storeSaga";
import collectionSaga from "./collectionSaga";

export default function* rootSaga() {
  yield all([
    gallerySaga(),
    artistSaga(),
    libraryCardSaga(),
    blogSaga(),
    storeSaga(),
    collectionSaga(),
  ]);
}
